/*
 * Copyright (c) 2023. Collabro Limited
 */
import React from "react";
import DnsIcon from "@mui/icons-material/Dns";
import {
  Checkbox,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import DynamicIcon from "../Icons/DynamicIcon";
import { RosterIcon } from "RosterData";

interface LayerProps {
  id: string;
  layerState?: String[];
  setLayerState?: any;
  disabled: boolean;
  name: string;
  description: string;
  iconName: RosterIcon;
}

const Layer = (props: LayerProps) => {
  const handleLayerClick = () => {
    props.setLayerState(props.id);
  };

  return (
    <ListItemButton disabled={props.disabled} onClick={handleLayerClick}>
      <ListItemIcon>
        <DynamicIcon iconName={props.iconName} />
      </ListItemIcon>
      <ListItemText primary={props.name} secondary={props.description} />
      {props.iconName === "BASE" ? (
        <Checkbox edge="end" defaultChecked />
      ) : (
        <Checkbox edge="end" checked={props.layerState!.includes(props.id)} />
      )}
    </ListItemButton>
  );
};

export default Layer;
